const enum EventName {
  NO_SEARCH_RESULTS_FOUND = 'No Search Results Found',
  INVALID_COUPON_CODE = 'Invalid Coupon Code',
  PDP_OUT_OF_STOCK = 'PDP Out Of Stock'
}

export default EventName;
